import { SalesTeam as m } from "./sales-team.js";
import { Team as r } from "./team.js";
import { AccountManagement as o } from "./account-management.js";
import { CommercialTeam as e } from "./commercial-team.js";
import { CommercialOperationsTeam as a } from "./commercial-operations-team.js";
import { CommunicationsTeam as t } from "./communications-team.js";
import { ComplianceTeam as i } from "./compliance-team.js";
import { DataAnalyticsTeam as p } from "./data-analytics-team.js";
import { FinanceTeam as f } from "./finance-team.js";
import { HumanResourcesTeam as n } from "./human-resources-team.js";
import { InfrastructureTeam as T } from "./infrastructure-team.js";
import { InternalAuditTeam as c } from "./internal-audit-team.js";
import { MarketingTeam as s } from "./marketing-team.js";
import { MerchantOperationsTeam as u } from "./merchant-operations-team.js";
import { PartnershipsTeam as l } from "./partnerships-team.js";
import { ProductDesignTeam as g } from "./product-design-team.js";
import { ProductManagementTeam as P } from "./product-management-team.js";
import { RiskTeam as S } from "./risk-team.js";
import { SecurityTeam as d } from "./security-team.js";
import { SupportAndServicesTeam as h } from "./support-and-services-team.js";
import { LegalTeam as A } from "./legal-team.js";
import { TechTeam as C } from "./tech-team.js";
import { DevelopmentTeam as M } from "./development-team.js";
import { PaymentPartnershipsTeam as y } from "./payment-partnerships-team.js";
import { StaffTeam as D } from "./staff-team.js";
const Y = {
  SalesTeam: m,
  Team: r,
  AccountManagement: o,
  CommercialTeam: e,
  CommercialOperationsTeam: a,
  CommunicationsTeam: t,
  ComplianceTeam: i,
  DataAnalyticsTeam: p,
  FinanceTeam: f,
  HumanResourcesTeam: n,
  InfrastructureTeam: T,
  InternalAuditTeam: c,
  MarketingTeam: s,
  MerchantOperationsTeam: u,
  PartnershipsTeam: l,
  ProductDesignTeam: g,
  ProductManagementTeam: P,
  RiskTeam: S,
  SecurityTeam: d,
  SupportAndServicesTeam: h,
  LegalTeam: A,
  TechTeam: C,
  DevelopmentTeam: M,
  PaymentPartnershipsTeam: y,
  StaffTeam: D
};
export {
  Y as TeamIcons
};
